import React from "react";
import CustomDropdownSelect from "src/business-types/grocery/components/DropdownSelect";

interface ExportSelectProps {
  orders: any[];
  selectedDate: string;
  selectedDate2: string;
  handleExport: (type: string, orders: any[], startDate: string, endDate: string) => void;
}

const EXPORT_OPTIONS = [
  { _id: "CSV", CategoryName: "CSV" },
  { _id: "PDF", CategoryName: "PDF" },
];

const ExportSelect: React.FC<ExportSelectProps> = ({ orders, selectedDate, selectedDate2, handleExport }) => {
  const handleSelectChange = async (value: string) => {
    if (value) {
      await handleExport(value, orders, selectedDate, selectedDate2);
    }
  };

  return (
    <CustomDropdownSelect
      title="Choose export file:"
      titleClassName="font-bold"
      name="exportOption"
      value=""
      titleofSelect="Select"
      options={EXPORT_OPTIONS}
      onChange={handleSelectChange}
      className="!mb-0 w-full"
    />
  );
};

export default ExportSelect;